import { fromPromise } from 'xstate'

import Api from '@/api/_legacy'

import { usersMachine } from '../../common/users.state'

const TENANT_ID = 'absa'

export const clientUsersMachine = usersMachine.provide({
  actors: {
    fetchUsers: fromPromise(async ({ input }: any) => {
      // XState v5: input contains { context, event }
      const { clientId } = input.context
      const response = await Api.tenant.usersDetail3(clientId, TENANT_ID)
      const data = response.data.users
      return data
    })
  }
})
